import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import InfoInformation from "./infoInformation";
import ReactPaginate from "react-paginate";
import {jwtDecode} from "jwt-decode"; // Importation corrigée
import { baseApiUrl } from "../../../services/api";

function Liste() {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [projectsPerPage] = useState(6); // Nombre de projets par page
  const [category, setCategory] = useState("Toutes");
  const [projects, setProjects] = useState([]); // État pour stocker les projets
  const [informations, setInformations] = useState([]); // État pour stocker les projets
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur
  const navigate = useNavigate();

  // Fonction pour récupérer les projets actifs ou d'une catégorie spécifique
  const fetchInformations = async () => {
    try {
      const response = await baseApiUrl.get("/information/liste");
      // Filtrer les projets actifs
      const filteredInformations = response.data.filter(
        (information) => information.actif === true
      );
      setInformations(filteredInformations);
      console.log("info récupérés :", filteredInformations);
    } catch (error) {
      console.error("Erreur lors de la récupération des info :", error);
    }
  };

  // Utilisation de useEffect pour initialiser les données
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté :", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token :", error);
      }
    }
    fetchInformations(); // Charger tous les projets actifs par défaut
  }, []);

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
    }
    return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const goToProjectDetail = (informationId) => {
    if (informationId) {
      navigate(`/information/${informationId}`);
    } else {
      console.error("L'ID du projet est indéfini !");
    }
  };

  // Filtrer les projets par le terme de recherche
  const filteredInfos = informations.filter((information) =>
    information.titre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const offset = currentPage * projectsPerPage;
  const currentInformations = filteredInfos.slice(
    offset,
    offset + projectsPerPage
  );

  return (
    <div className="liste">
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1>Actualités</h1>
                <h3 style={{ fontSize: "18px", color: "white" }}>
                  L'actualité représente un ensemble de données ou de
                  connaissances partagées afin d'éclairer, de sensibiliser ou
                  d'éduquer un public sur un sujet spécifique.
                </h3>
              </div>
            </div>
          </div>
         
        </div>
      </div>

      <div className="blog1 sp bg1 _relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tab-content categories-content-tab">
                <div
                  className="tab-pane fade show active"
                  role="tabpanel"
                  aria-labelledby="category-tab1-tab"
                >
                  <div className="blog1-posts-area">
                    <div className="row">
                      {currentInformations.map((information, index) => (
                        <InfoInformation key={index} information={information} />
                      ))}
                    </div>
                    <div className="space60"></div>
                    <div
                      className="row"
                      data-aos-offset="50"
                      data-aos-duration="400"
                    >
                      <div className="col-12 m-auto">
                        <div className="theme-pagination text-center">
                          <ReactPaginate
                            previousLabel={<i className="fa-solid fa-angle-left"></i>}
                            nextLabel={<i className="fa-solid fa-angle-right"></i>}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(filteredInfos.length / projectsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default Liste;
